export const paths = {
    shop: '/',
    shoppingCart: '/shopping-cart',
    history: '/history',
}